"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoggerFactory = void 0;
var service_1 = require("../service");
var LoggerFactory = (function () {
    function LoggerFactory() {
    }
    LoggerFactory.createLogger = function () {
        if (!this.logger) {
            this.logger = new service_1.ConsoleLogger();
            return this.logger;
        }
        return this.logger;
    };
    LoggerFactory.logger = null;
    return LoggerFactory;
}());
exports.LoggerFactory = LoggerFactory;
//# sourceMappingURL=LoggerFactory.js.map